<template>
    <div>
        <div class="modal-container has-text-centered">
            <div class="has-text-centered">
                
                  
                    <div class="is-size-3">Congratulations!</div >

                   <!--  <img class="top5" src="@/assets/img/Miimu logo.png" width="300"/><br/>
 -->
                    <div class="is-size-4"><b>You've experienced the magic of </b><img src="@/assets/img/Miimu logo.png" width="120" class="posRelative" style="top:4px"/></div>
                    
                   <img src="@/assets/img/miica.png" width="150" class="top40" />

                    <div class="top20 is-size-4">
                        What would you like to do next?
                    </div>
                   
                    <div  class="top20 button handCursor is-coolGreen" @click="start">
                        <b>Make another miimu</b>
                    </div>
                    &nbsp;
                    <!-- <div  class="top20 button handCursor is-coolGreen">
                        <b>Watch our new miimu guidde</b>
                    </div> -->
                    &nbsp;
                    <div  class="top20 button handCursor" @click="cancel">
                        <b>Exit Wizard</b>
                    </div>

                    
            </div>
        </div>
    </div>

</template>

<script>
export default {
  props: {message: String, callBack: Function, payload: Object},
  methods: {

      start: function(){
        this.$parent.$parent.startTour()
        this.$emit('close')
      },
    
      cancel: function(){
          this.$emit('close')
      }
  }
}
</script>

<style scoped>
    #title{
        font-size: 1.5rem;
    }
    .modal-container{
        max-width: 700px;
        padding: 40px
    }
    .body-bott{
        position: absolute;
        right: 15px;
        bottom: 20px;
        width: 100%;
    }
    .notification{
        height: 100%;
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
   

</style>
